// react
import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// core components
import Card from "beaktShared/components/Card/Card.js";
import DadosCliente from "./Steps/DadosCliente.js";
import DadosMedidas from "./Steps/DadosMedidas.js";
import ResultadoEmagrecentro from "./Steps/ResultadoEmagrecentro.js";
import ResultadoDrDiabetes from "./Steps/ResultadoDrDiabetes.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";

// services
import { getAvaliacaoCookie, getAvaliacaoConsultaCookie } from 'beaktClinic/services/avaliacaoCookie';
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// style
import { makeStyles } from "@material-ui/core/styles";
import wizardStyle from "assets/jss/material-dashboard-pro-react/components/wizardStyle.js";

const useStyles = makeStyles(wizardStyle);

export default function Avaliacao() {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);

  const [avaliacaoFranquia, set_avaliacaoFranquia] = React.useState("");

  useEffect(() => {
    UseGetApiSimple("Franquias/GetByEstabelecimento/" + session.estabelecimentoId).then((result) => {
      if (result.status == 200) {
        if (result.data.avaliacao == "" || result.data.avaliacao == null)
          set_avaliacaoFranquia("Nenhum");
        else
        {
          set_avaliacaoFranquia(result.data.avaliacao);
          session.franquiaId = result.data.franquiaId;
        }

        if (result.data.avaliacao == "Emagrecentro" || result.data.avaliacao == "Dr. Diabetes") {
          refreshAnimation(0);
        }
      }
    });
  }, []);

  const [qtdsteps, setqtdsteps] = React.useState(3);
  const [currentStepName, setcurrentStepName] = React.useState(t('avaliation.client_data'));
  const [currentStep, setcurrentStep] = React.useState(0);
  const [previousButton, setpreviousButton] = React.useState(false);
  const [nextButton, setnextButton] = React.useState(qtdsteps > 1 ? true : false);
  const [finishButton, setfinishButton] = React.useState(qtdsteps === 1 ? true : false);

  var widthtemp = 100 / qtdsteps;

  const [width, setwidth] = React.useState(widthtemp);

  const [movingTabStyle, setmovingTabStyle] = React.useState({
    transition: "transform 0s"
  });
  const wizard = React.useRef();

  useEffect(() => {

    refreshAnimation(0);

    let avaliacao = getAvaliacaoCookie();
    if (getAvaliacaoConsultaCookie() != null)
      avaliacao = getAvaliacaoConsultaCookie();
    if (avaliacao !== null && avaliacao.length !== 0 && (avaliacao.avaliacaoId != null || avaliacao.kg != null)) {
      setcurrentStep(2);
      updateStepName(2);
      setnextButton(false);
      setpreviousButton(false);
      setfinishButton(false);
      refreshAnimation(2);
    }

  }, [refreshAnimation]);

  useEffect(() => {
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, [currentStep]);

  const updateWidth = () => {
    refreshAnimation(currentStep);
  }

  const refreshAnimation = (index) => {
    var total = qtdsteps;
    var li_width = 100 / total;
    var total_steps = qtdsteps;
    var move_distance = wizard.current.children.length > 0 && wizard.current.children[0].offsetWidth / total_steps;
    var index_temp = index;
    var vertical_level = 0;

    var mobile_device = window.innerWidth < 600 && total > 3;

    if (mobile_device) {
      move_distance = wizard.current.children[0].offsetWidth / 2;
      index_temp = index % 2;
      li_width = 50;
    }

    setwidth(li_width + "%");

    var step_width = move_distance;
    move_distance = move_distance * index_temp;

    var current = index + 1;

    if (current === 1 || (mobile_device === true && index % 2 === 0)) {
      move_distance -= 8;
    } else if (
      current === total_steps ||
      (mobile_device === true && index % 2 === 1)
    ) {
      move_distance += 8;
    }

    if (mobile_device) {
      vertical_level = parseInt(index / 2, 10);
      vertical_level = vertical_level * 38;
    }
    setmovingTabStyle({
      width: step_width,
      transform:
        "translate3d(" + move_distance + "px, " + vertical_level + "px, 0)",
      transition: "all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)"
    });
  }

  const navigationStepChange = (key) => {

    //if(key == 2 || key == 1 || ){
    return;
    //}

    setcurrentStep(key);
    updateStepName(key);
    setpreviousButton(key > 0 ? true : false);
    setnextButton(qtdsteps > key + 1 ? true : false);
    setfinishButton(qtdsteps === key + 1 ? true : false);
    refreshAnimation(key);
  }

  const nextButtonClick = () => {

    var key = currentStep + 1;
    setcurrentStep(key);
    updateStepName(key);
    setnextButton(qtdsteps > key + 1 ? true : false);
    setpreviousButton(key > 0 ? true : false);
    setfinishButton(qtdsteps === key + 1 ? true : false);
    refreshAnimation(key);
  }

  const previousButtonClick = () => {
    var key = currentStep - 1;
    if (key >= 0) {
      setcurrentStep(key);
      updateStepName(key);
      setnextButton(qtdsteps > key + 1 ? true : false);
      setpreviousButton(key > 0 ? true : false);
      setfinishButton(qtdsteps === key + 1 ? true : false);
      refreshAnimation(key);
    }
  }

  const previousButtonDoubeClick = () => {
    var key = currentStep - 2;
    if (key >= 0) {
      setcurrentStep(key);
      updateStepName(key);
      setnextButton(qtdsteps > key + 1 ? true : false);
      setpreviousButton(key > 0 ? true : false);
      setfinishButton(qtdsteps === key + 1 ? true : false);
      refreshAnimation(key);
    }
  }

  const updateStepName = (index) => {
    if (index === 0)
      setcurrentStepName(t('avaliation.client_data'));
    else if (index === 1)
      setcurrentStepName(t('avaliation.measures_data'));
    else if (index === 2)
      setcurrentStepName(t('avaliation.avaliation_result'));
  }

  return (
    <div className="maxContent">
      <div className={classes.wizardContainer} ref={wizard}>
        {(avaliacaoFranquia == "Emagrecentro" || avaliacaoFranquia == "Dr. Diabetes") &&
          <Card className={classes.card}>
            <div className="no-print">
              <div className={classes.wizardHeader}>
                <h3 className={classes.title}> {t('sidebar.avaliation')}</h3>
                <h5 className={classes.subtitle + " no-print"}>
                  {t('avaliation.make_new_avaliation')}
                </h5>
              </div>
            </div>
            <div className={classes.wizardNavigation}>
              <ul className={classes.nav}>
                <li className={classes.steps + " no-print"}
                  style={{ width: width }}>
                  <a
                    href="#pablo"
                    className={classes.stepsAnchor}
                    onClick={e => {
                      e.preventDefault();
                      navigationStepChange(0);
                    }}
                  >
                    {t('avaliation.client_data')}
                  </a>
                </li>
                <li
                  className={classes.steps + " no-print"}
                  style={{ width: width }}>
                  <a
                    href="#pablo"
                    className={classes.stepsAnchor}
                    onClick={e => {
                      e.preventDefault();
                      navigationStepChange(1);
                    }}
                  >
                    {t('avaliation.measures_data')}
                  </a>
                </li>
                <li className={classes.steps + " no-print"}
                  style={{ width: width }}>
                  <a
                    href="#pablo"
                    className={classes.stepsAnchor}
                    onClick={e => {
                      e.preventDefault();
                      navigationStepChange(2);
                    }}
                  >
                    {t('avaliation.avaliation_result')}
                  </a>
                </li>

              </ul>
              <div
                className={classes.movingTab + " " + classes['primary']}
                style={movingTabStyle}
              >
                {currentStepName}
              </div>
            </div>
            <div className={classes.content}>
              
              {currentStep === 0 &&
                <DadosCliente nextButtonClick={nextButtonClick} classes_wizard={classes}></DadosCliente>
              }
              {currentStep === 1 &&
                <DadosMedidas 
                  nextButtonClick={nextButtonClick} 
                  previousButtonClick={previousButtonClick} 
                  classes_wizard={classes} 
                  avaliacaoFranquia={avaliacaoFranquia}>
                </DadosMedidas>
              }
              {currentStep === 2 && avaliacaoFranquia == "Emagrecentro" &&
                <ResultadoEmagrecentro previousButtonClick={previousButtonDoubeClick} classes_wizard={classes}></ResultadoEmagrecentro>
              }
              {currentStep === 2 && avaliacaoFranquia == "Dr. Diabetes" &&
                <ResultadoDrDiabetes previousButtonClick={previousButtonDoubeClick} classes_wizard={classes}></ResultadoDrDiabetes>
              }
            </div>
          </Card>
        }
      </div>
      {avaliacaoFranquia == "Nenhum" &&
        <GridContainer>
          <GridItem>
            <h4>Sem configuração de Avaliação</h4>
          </GridItem>
        </GridContainer>
      }
    </div>
  );
}